(() => {
  const descriptionSelectors = [
    '.product__description',
    '.product__description-block',
    '[data-product-description]',
    '.rte'
  ];

  function hideBrokenImage(image) {
    if (!image.closest(descriptionSelectors.join(','))) return;

    image.classList.add('vc-broken-product-image');
    image.removeAttribute('height');
    image.style.removeProperty('height');
    image.style.removeProperty('min-height');

    const wrapper = image.closest('picture, figure, p');
    if (wrapper && !wrapper.textContent.trim() && wrapper.querySelectorAll('img').length === 1) {
      wrapper.classList.add('vc-empty-product-media');
      wrapper.removeAttribute('style');
    }
  }

  function inspect(root = document) {
    root.querySelectorAll(descriptionSelectors.map((selector) => `${selector} img`).join(','))
      .forEach((image) => {
        image.addEventListener('error', () => hideBrokenImage(image), { once: true });
        if (image.complete && image.naturalWidth === 0) hideBrokenImage(image);
      });
  }

  document.addEventListener('DOMContentLoaded', () => {
    inspect();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) inspect(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
